<template>
  <div class="d-block px-2 py-3">
    <v-expansion-panels
      v-model="panel"
      id="filter-produkcard"
      tile
      accordion
      focusable
      class="accordion-filter d-none"
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          class="text-uppercase font-weight-bold text-body-2 px-3 py-3 mt-5"
          >
          <div><v-icon>mdi-filter-outline</v-icon> Filter</div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="px-4 pt-4 pb-0 mt-2 border" outlined>
          <v-form>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  v-model="productNameFilter.value"
                  outlined
                  small
                  dense
                  hide-details
                  class="searchInput"
                  placeholder="cari nama produk atau SKU"
                >
                  <div slot="append">
                    <v-btn
                      small
                      elevation="2"
                      color="success"
                    >
                      <v-icon center>
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </div>
                </v-text-field>
              </v-col>

              <v-col cols="6" class="py-0">
                <v-select
                  v-model="productCategoryFilter.value"
                  :items="category"
                  item-text="product_category_name"
                  item-value="product_category_id"
                  placeholder="Pilih Kategori"
                  outlined
                  multiple
                  dense
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="py-0">
                <v-row class="align-center">
                  <v-col cols="3" class="py-0">
                    Stok
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productStockMinFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1" class="py-0">
                    -
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productStockMaxFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="6" class="py-0">
                <v-row class="align-center">
                  <v-col cols="3" class="py-0">
                    Penjualan
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productSoldMinFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1" class="py-0">
                    -
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-currency-field
                      v-model="productSoldMaxFilter.value"
                      outlined
                      small
                      dense
                      hide-details
                    ></v-currency-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-right pb-0 pt-5 mt-3">
                <v-btn
                  color="success"
                  elevation="2"
                  dark
                  class="mr-3"
                  width="140"
                  @click="cari"
                >
                  <strong class="text-uppercase">Cari</strong>
                </v-btn>

                <v-btn
                  color="error"
                  elevation="2"
                  outlined
                  dark
                  width="140"
                  @click="resetFilter"
                >
                  <strong class="text-uppercase">Reset</strong>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row class="align-center" :class="{'my-4': !isMobile}">
      <v-col cols="12" sm="6">
        <div class="text-subtitle-2 font-weight-bold">
          {{product_by_type.title}}
          <v-chip
            small
            class="ma-2"
            :color="product_by_type.colorCount"
            outlined
          >
            {{ productPagination.total_data }}
          </v-chip>
        </div>
      </v-col>
      <v-col cols="12" sm="6" class="text-right" :class="{'d-none': isMobile}">
      </v-col>
    </v-row>

    <v-layout v-resize="onResize" column>
      <v-data-table
        :server-items-length="productPagination.total_data"
        hide-default-footer
        v-model="selected"
        :headers="headers"
        :loading="loading"
        :items="productInternalData"
        :expanded.sync="expanded"
        single-expand
        item-key="product_id"
        class="elevation-1 border"
        :class="{mobile: isMobile}"
        id="product-table"
      >
        <template v-slot:header.product_name="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.product_price="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.product_sold_count="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.product_is_active="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:header.store_stock_quantity="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>

        <template v-slot:item.product_name="{ item }">
          <div class="d-flex" :class="(isMobile) ? 'flex-column align-start justify-start' : 'flex-row align-center'">
            <v-img :width="(isMobile) ? 120 : 80" :max-width="(isMobile) ? 80 : 50"  class="mr-3 my-3" :src="item.product_image[0] ? item.product_image[0] : '/assets/product/default.png'"></v-img>
            <div class="font-weight-bold no-line green--text">{{ item.product_name }}</div>
          </div>
        </template>
        <template v-slot:item.product_price="{ item }">
          {{ item.product_price | toRupiah }}
        </template>
        <template v-slot:item.product_is_active="{ item }">
          <v-switch
            v-model="item.product_is_active"
            true-value="active"
            false-value="inactive"
            class="pa-3"
            dense
            @change="ubahStatus($event, item.product_id)"
          ></v-switch>
        </template>

        <template v-slot:expanded-item="{ headers, item }" v-if="false">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="12" class="text-right">

                <v-btn
                  small
                  color="grey darken-2"
                  elevation="1"
                  outlined
                  tile
                  dark
                  class="white mr-2"
                  @click="openReminderDialog(item)"
                  v-if="false"
                >
                  <span class="text-capitalize font-weight-medium black--text"><v-icon small class="grey--text darken-1 font-weight-normal mr-2">mdi-bell-ring-outline</v-icon>Pengingat Stok</span>
                </v-btn>
              </v-col>
            </v-row>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img width="260" class="py-5 my-4" src="/assets/seller/belum-ada-barang.svg"></v-img>
            <div class="text-h6 black--text">Produk yang Anda cari tidak ditemukan</div>
            <!-- <p>Barang jualan kamu akan muncul di halaman ini. Ayo mulai berjualan di <strong class="green--text">Pasaroa</strong> sekarang!</p> -->
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination v-if="productPagination.total_page > 1 && productInternalData.length > 0" @input="updatePage" v-model="page" :length="productPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus py-2"></v-pagination>

    <v-dialog
      v-model="dialogReminderStock"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="headline text-capitalize green--text darken-4">
          Pengingat Stok
        </v-card-title>
        <v-card-text class="pb-0" v-if="selectedItem">
          <div class="text-center font-weight-bold my-5 grey lighten-3 px-3 py-3">
            <p class="mb-0">{{ selectedItem.nama }}</p>
          </div>
          <v-row class="d-flex justify-start align-start">
            <v-col cols="2">
              <v-switch
                v-model="selectedItem.reminder"
                @change="(selectedItem.reminder === 1) ? selectedItem.reminder = 0 : selectedItem.reminder = 1"
                class="mt-0"
                dense
              ></v-switch>
            </v-col>
            <v-col cols="10" class="pl-0">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Pengingat Stok</div>
              <div class="d-flex flex-row align-center">
                <span class="text-caption pr-4 col-8 px-0">Pengingat akan aktif jika Stok produk kurang dari</span>
                <v-text-field
                  v-model="selectedItem.minStock"
                  outlined
                  x-small
                  dense
                  hide-details
                  :disabled="(selectedItem.reminder === 1) ? false : true"
                  width="100px"
                ></v-text-field>
                <span class="col-2"></span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <v-btn
              color="green darken-1 white--text"
              @click="dialogReminderStock = false, selectedItem = null"
              class="my-2 px-5"
            >
              Simpan
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {

  data() {
    return {
      page: 1,
      limit: 8,
      params: [],
      sort: {},
      sortBy: '',
      sortDir: '',
      loading: false,
      isMobile: false,
      panel: [0],

      productCategoryFilter: {
        value: '',
        comparison: '=',
        type: 'string',
        field: 'product_category_id',
      },
      productNameFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'product_name',
      },
      productStockMinFilter: {
        value: '',
        comparison: '>',
        type: 'numeric',
        field: 'store_stock_quantity',
      },
      productStockMaxFilter: {
        value: '',
        comparison: '<',
        type: 'numeric',
        field: 'store_stock_quantity',
      },
      productSoldMinFilter: {
        value: '',
        comparison: '>',
        type: 'numeric',
        field: 'product_sold_count',
      },
      productSoldMaxFilter: {
        value: '',
        comparison: '<',
        type: 'numeric',
        field: 'product_sold_count',
      },

      filter: {
        search: '',
        categoryId: null,
        minStock: 0,
        maxStock: 0,
        minSold: 0,
        maxSold: 0
      },
      categories: [
        {
          categoryId: 1,
          nama: 'Makanan & Minunman'
        },
        {
          categoryId: 2,
          nama: 'Gadget & Aksesoris'
        },
        {
          categoryId: 3,
          nama: 'Pakaian Wanita'
        },
        {
          categoryId: 4,
          nama: 'Fashion Bayi & Anak'
        },
        {
          categoryId: 5,
          nama: 'Tas Pria'
        }
      ],
      selected: [],
      expanded: [],
      headers: [
        {
          text: 'Info Produk',
          align: 'start',
          sortable: false,
          value: 'product_name',
        },
        { text: 'Harga', value: 'product_price', sortable: false },
        { text: 'Stok', value: 'store_stock_quantity', sortable: false },
        { text: 'Penjualan', value: 'product_sold_count', sortable: false },
        { text: 'Status', value: 'product_is_active', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ],
      products: [
        {
          nama: 'Vans OldSkool Canvas Black/White',
          thumbnails: 'https://images.vans.com/is/image/Vans/D3HY28-HERO?$583x583$',
          product_price: 650000,
          store_stock_quantity: 12,
          product_sold_count: 5,
          product_is_active: 1,
          reminder: 0,
          minStock: 0
        },
        {
          nama: 'PUMA EM125EM White',
          thumbnails: 'https://ecs7.tokopedia.net/img/cache/700/product-1/2018/10/31/4550220/4550220_b527019f-b6ee-4f55-8832-13846e355746_698_698.jpg',
          product_price: 855000,
          store_stock_quantity: 20,
          product_sold_count: 10,
          product_is_active: 0,
          reminder: 0,
          minStock: 0
        }
      ],
      selectedItem: null,
      dialogReminderStock:false
    }
  },

  props:{
    type: String
  },

  computed: {
    ...mapState('productSeller', ['productInternalData', 'productPagination']),
    ...mapState('category', ['category']),

    product_by_type() {
      let dataType = {
        title: 'Semua Produk',
        colorCount: 'green',
      }

      switch (this.type) {
        case 'all':
        dataType = {
          title: 'Semua Produk',
          colorCount: 'green',
        }
        break

        case 'live':
        dataType = {
          title: 'Produk Live',
          colorCount: 'green',
        }
        break

        case 'sold-out':
        dataType = {
          title: 'Produk Habis',
          colorCount: 'error',
        }
        break

        default:
        return {
          title: 'Semua Produk',
          colorCount: 'green',
        }
      }

      return dataType
    }
  },

  methods: {
    ...mapActions('productSeller', ['getProductInternal', 'statusProduct','removeProduct']),

    async ubahStatus(val, id) {
      await this.statusProduct({
        id: id,
        status: val,
      }).then(() => {
        this.getDataProduct()
      })
    },
    async getDataProduct() {
      this.loading = await true
      switch (this.type) {

        case 'all':
        break;

        case 'live':
        this.params.push({
          value: 'active',
          comparison: '=',
          type: 'string',
          field: 'product_is_active',
        })
        break;

        case 'sold-out':
        this.params.push({
          value: '0',
          comparison: '=',
          type: 'numeric',
          field: 'store_stock_quantity',
        })
        break;
      }
      await this.getProductInternal(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      )
      this.loading = false
    },
    cari() {
      this.params = []

      if (this.productNameFilter.value) this.params.push(this.productNameFilter)
      if (this.productCategoryFilter.value) this.params.push(this.productCategoryFilter)
      if (this.productStockMinFilter.value) this.params.push(this.productStockMinFilter)
      if (this.productStockMaxFilter.value) this.params.push(this.productStockMaxFilter)
      if (this.productSoldMinFilter.value) this.params.push(this.productSoldMinFilter)
      if (this.productSoldMaxFilter.value) this.params.push(this.productSoldMaxFilter)

      this.sortBy = this.sort.sortBy
      this.sortDir = this.sort.sortDir
      this.page = 1
      this.getDataProduct()
    },
    resetFilter() {
      this.productNameFilter.value = ''
      this.productCategoryFilter.value = ''
      this.productStockMinFilter.value = ''
      this.productStockMaxFilter.value = ''
      this.productSoldMinFilter.value = ''
      this.productSoldMaxFilter.value = ''
      this.cari()
    },
    async openReminderDialog(item) {
      this.selectedItem = await item
      this.dialogReminderStock = true
    },

    addProduk() {
      this.$router.push({ path : '/seller/tambah-produk' })
    },
    updatePage(val) {
      this.page = val
      this.getDataProduct()
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  created() {
    this.$store.dispatch('setPageTitle', 'Produk Saya');
    this.getDataProduct()
  },
  
}
</script>